import React from 'react';

import Modals from '../Modals/Modals';
import BuildBanner from '../PageBanners/BuildBanner';
import GlobalPromo from '../PageBanners/GlobalPromo';
import Header from '../SiteLockup/Header/PlatformDetectHeader';
import Footer from '../SiteLockup/Footer';
import PageDefaults from '../PageDefaults';

function Layout({ children }) {
  return (
    <>
      <Modals />
      <BuildBanner />
      <GlobalPromo />
      <Header />
      <PageDefaults>{children}</PageDefaults>
      <Footer />
    </>
  );
}

export default Layout;
